"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dangerouslyReplaceArrayChild = dangerouslyReplaceArrayChild;
exports.dangerouslyReplaceObjectChild = dangerouslyReplaceObjectChild;
exports.dangerouslySetChildren = dangerouslySetChildren;
exports.foldMapShapedTree = foldMapShapedTree;
exports.forgetShape = forgetShape;
exports.getRootData = getRootData;
exports.mapRoot = mapRoot;
exports.mapShapedTree = mapShapedTree;
exports.pathExistsInTree = pathExistsInTree;
exports.rootPath = void 0;
exports.shapePath = shapePath;
exports.shapedArrayChild = shapedArrayChild;
exports.shapedArrayChildren = shapedArrayChildren;
exports.shapedObjectChild = shapedObjectChild;
exports.treeFromValue = treeFromValue;
exports.updateAtPath = updateAtPath;

var _tree = require("./tree");

var _invariant = _interopRequireDefault(require("./utils/invariant"));

var _array = require("./utils/array");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rootPath = function rootPath() {
  return [];
}; // Take shape from value, data from nodeData


exports.rootPath = rootPath;

function treeFromValue(value, nodeData) {
  if (Array.isArray(value)) {
    return {
      type: "array",
      data: nodeData,
      children: value.map(function (child) {
        return treeFromValue(child, nodeData);
      })
    };
  }

  if (value instanceof Object) {
    // $FlowFixMe[class-object-subtyping]: instance of Object class is really just the object type
    var objectValue = value;
    return {
      type: "object",
      data: nodeData,
      children: Object.keys(objectValue).reduce(function (children, k) {
        return _objectSpread(_objectSpread({}, children), {}, _defineProperty({}, k, treeFromValue(objectValue[k], nodeData)));
      }, {})
    };
  }

  return {
    type: "leaf",
    data: nodeData
  };
}

function shapePath(data, path) {
  if (path.length === 0) {
    return path;
  }

  var _path = _toArray(path),
      firstPart = _path[0],
      restParts = _path.slice(1);

  if (firstPart.type === "object" && Object.hasOwnProperty.call(data, firstPart.key)) {
    // $FlowFixMe[incompatible-use]: This is safe
    var restPath = shapePath(data[firstPart.key], restParts);

    if (restPath === null) {
      return null;
    }

    return [firstPart].concat(_toConsumableArray(restPath));
  } else if (firstPart.type === "array" && Array.isArray(data) && firstPart.index < data.length) {
    var _restPath = shapePath(data[firstPart.index], restParts);

    if (_restPath === null) {
      return null;
    }

    return [firstPart].concat(_toConsumableArray(_restPath));
  }

  return null;
}

function pathExistsInTree(path, tree) {
  // This function is equivalent to:
  // try {
  //   updateAtPath(path, x => x, tree);
  // } catch {
  //   return false;
  // }
  // return true;
  // }
  if (path.length === 0 && tree.type != null) {
    return true;
  }

  var _path2 = _toArray(path),
      first = _path2[0],
      rest = _path2.slice(1);

  if (tree.type === "leaf") {
    return false;
  }

  if (tree.type === "array") {
    if (first.type !== "array") {
      return false;
    }

    if (!(0 <= first.index && first.index < tree.children.length)) {
      return false;
    }

    return pathExistsInTree(rest, tree.children[first.index]);
  }

  if (tree.type === "object") {
    if (first.type !== "object") {
      return false;
    }

    if (!(first.key in tree.children)) {
      return false;
    }

    return pathExistsInTree(rest, tree.children[first.key]);
  }

  throw new Error("unreachable");
}

function updateAtPath(path, updater, tree) {
  if (path.length === 0) {
    if (tree.type === "object") {
      return {
        type: "object",
        data: updater(tree.data),
        children: tree.children
      };
    }

    if (tree.type === "array") {
      return {
        type: "array",
        data: updater(tree.data),
        children: tree.children
      };
    }

    return {
      type: "leaf",
      data: updater(tree.data)
    };
  }

  var _path3 = _toArray(path),
      firstStep = _path3[0],
      restStep = _path3.slice(1);

  if (tree.type === "leaf") {
    throw new Error("Theres more key, but not more Tree to match it against");
  }

  if (tree.type === "array") {
    (0, _invariant["default"])(firstStep.type === "array", "Trying to take a non-array path into an array");
    (0, _invariant["default"])(0 <= firstStep.index && firstStep.index < tree.children.length, "Tried to take path index ".concat(firstStep.index, " but array from tree has length ").concat(tree.children.length));
    var newChild = updateAtPath(restStep, updater, tree.children[firstStep.index]); // $FlowFixMe[incompatible-return](zach): I think this is safe, might need GADTs for the type checker to understand why

    return dangerouslyReplaceArrayChild(firstStep.index, newChild, tree);
  }

  if (tree.type === "object") {
    (0, _invariant["default"])(firstStep.type === "object", "Trying to take a non-object path into an object");
    var nextTree = tree.children[firstStep.key];
    (0, _invariant["default"])(nextTree !== undefined, "Tried to take path key ".concat(firstStep.key, " but it isn't present on object in tree"));

    var _newChild = updateAtPath(restStep, updater, nextTree); // $FlowFixMe[incompatible-call](zach): I think this is safe, might need GADTs for the type checker to understand why


    return dangerouslyReplaceObjectChild(firstStep.key, _newChild, tree);
  }

  throw new Error("unreachable");
}

function shapedArrayChild(index, tree) {
  (0, _invariant["default"])(tree.type === "array", "Tried to get an array child of a non-array node");
  return tree.children[index];
}

function shapedArrayChildren(tree) {
  (0, _invariant["default"])(tree.type === "array", "Tried to get an array children of a non-array node");
  return tree.children.map(function (x) {
    return x;
  });
} // TODO(zach): not sure what to do about this output variable


function shapedObjectChild(key, tree) {
  (0, _invariant["default"])(tree.type === "object", "Tried to get object child of a non-object node");
  return tree.children[key];
}

function forgetShape(tree) {
  return tree;
}

function mapRoot(f, tree) {
  if (tree.type === "object") {
    return {
      type: "object",
      data: f(tree.data),
      children: tree.children
    };
  }

  if (tree.type === "array") {
    return {
      type: "array",
      data: f(tree.data),
      children: tree.children
    };
  }

  return {
    type: "leaf",
    data: f(tree.data)
  };
} // Do not use this unless you really know what you are doing
// It is unsafe, and intended to bypass some checks


function dangerouslyReplaceObjectChild(key, child, tree) {
  (0, _invariant["default"])(tree.type === "object", "Tried to replace child of a non-object node");
  return {
    type: "object",
    data: tree.data,
    children: _objectSpread(_objectSpread({}, tree.children), {}, _defineProperty({}, key, child))
  };
} // Do not use this unless you really know what you are doing
// It is unsafe, and intended to bypass some checks


function dangerouslyReplaceArrayChild(index, child, tree) {
  (0, _invariant["default"])(tree.type === "array", "Tried to replace child of a non-array node");
  return {
    type: "array",
    data: tree.data,
    children: (0, _array.replaceAt)(index, child, tree.children)
  };
} // Do not use this unless you really know what you are doing
// It is intended to bypass some checks when modifying arrays


function dangerouslySetChildren(children, tree) {
  (0, _invariant["default"])(tree.type === "array", "Tried to set children of a non-array node");
  return {
    type: "array",
    data: tree.data,
    children: children.map(forgetShape)
  };
} // Mapping doesn't change the shape


function mapShapedTree(f, tree) {
  return (0, _tree.mapTree)(f, tree);
} // Fold a tree inorder


function foldMapShapedTree(mapper, mempty, mappend, tree) {
  return (0, _tree.foldMapTree)(mapper, mempty, mappend, tree);
}

function getRootData(tree) {
  return tree.data;
}